// src/components/Jozwe/JozvePaymentModal.jsx
import { useState, useEffect } from "react";
import { useCoins } from "../../../context/CoinContext";
import "./JozvePaymentModal.css";

const JozvePaymentModal = ({ open, lesson, onClose, onSuccess, itemKind = 'jozve' }) => {
  const { coins, removeCoins } = useCoins();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // ریست state هر بار باز شدن
  useEffect(() => {
    if (open) {
      setLoading(false);
      setError(null);
    }
  }, [open]);

  if (!open || !lesson) return null;

  const coinPrice = Number(lesson.coinPrice) || 0;
  const hasEnough = coins >= coinPrice;
  const shortage = Math.max(0, coinPrice - coins);

  const handleConfirm = async () => {
    if (!hasEnough || loading) return;
    setLoading(true);
    setError(null);

    try {
      const removed = removeCoins(coinPrice);
      if (!removed || removed <= 0) {
        throw new Error("لطفاً یک لحظه صبر کنید و دوباره امتحان کنید.");
      }
      // callback والد: ثبت خرید + دانلود
      if (onSuccess) {
        await onSuccess();
      }
      onClose();
    } catch (e) {
      setError(e.message || "خطا در پرداخت با سکه");
      setLoading(false);
    }
  };

  return (
    <div className="jozve-modal-backdrop" onClick={loading ? undefined : onClose}>
      <div className="jozve-modal" onClick={(e) => e.stopPropagation()}>
        {/* هدر با آیکن طلایی */}
        <div className="jozve-modal-header">
          <div className="jozve-modal-icon">
            {lesson.badge === "پرفروش" ? "👑" : "⭐"}
            <div className="jozve-modal-icon-pulse" />
          </div>
          <h3 className="jozve-modal-title">{lesson.title}</h3>
          {lesson.description && (
            <p className="jozve-modal-desc">{lesson.description}</p>
          )}
          <span className="jozve-modal-tag">{itemKind === 'exam' ? 'نمونه سوال ویژه' : 'جزوه ویژه'}</span>
        </div>

        {/* قیمت و موجودی */}
        <div className="jozve-modal-prices">
          <div className="jozve-modal-price-card">
            <span className="jozve-modal-price-label">قیمت</span>
            <span className="jozve-modal-price-value">
              🪙 {coinPrice.toLocaleString("fa-IR")}
            </span>
          </div>
          <div className={`jozve-modal-price-card ${hasEnough ? "is-ok" : "is-short"}`}>
            <span className="jozve-modal-price-label">موجودی شما</span>
            <span className="jozve-modal-price-value">
              🪙 {coins.toLocaleString("fa-IR")}
            </span>
          </div>
        </div>

        {/* هشدار کمبود */}
        {!hasEnough && (
          <div className="jozve-modal-shortage">
            ⚠️ {shortage.toLocaleString("fa-IR")} سکه کم دارید
          </div>
        )}

        {error && <div className="jozve-modal-error">{error}</div>}

        {/* دکمه‌ها */}
        <div className="jozve-modal-actions">
          <button
            className="jozve-modal-btn is-cancel"
            onClick={onClose}
            disabled={loading}
          >
            انصراف
          </button>
          <button
            className="jozve-modal-btn is-primary"
            onClick={handleConfirm}
            disabled={!hasEnough || loading}
          >
            {loading
              ? "در حال پردازش..."
              : hasEnough
                ? `🪙 پرداخت ${coinPrice.toLocaleString("fa-IR")} سکه`
                : "سکه کافی نیست"}
          </button>
        </div>

        <p className="jozve-modal-hint">
          با پرداخت سکه، فایل بلافاصله دانلود می‌شود و برای همیشه در دسترس شماست.
        </p>
      </div>
    </div>
  );
};

export default JozvePaymentModal;